module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "agreement"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-agreement"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Agreement.title')))]), _vm._v(" "), (_vm.errorMsg !== '') ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "sl-table-sm"
    }, [_c('ul', [_c('li', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/imgs/T-" + (item.channelId) + ".png"),
        "alt": ""
      }
    }), _c('span', [_vm._v(_vm._s(item.channelName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(item.settleWay) + "+" + _vm._s(item.settlePeriod))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s((item.rate / 100).toFixed(2)) + "%")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.next')))])], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f03a896!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/on-boarding/agreement.vue
// module id = 1087
// module chunks = 1